module.exports = __webpack_public_path__ + "static/img/10005 (1).b6f395e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10005 (1).webp
// module id = Ex+l
// module chunks = 14